import pick from 'lodash/pick';
import { printAstToDoc } from './print-ast-to-doc';
import { printDocToString } from './print-doc-to-string';
/**
 * Print the provided AST object into a formatted JQL string.
 */
export var print = function print(jast) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return printDocToString(printAstToDoc(jast, pick(options, ['operatorCase'])), pick(options, ['printWidth']));
};